import React from 'react';
import { SEOTableData } from 'src/api/models/SEOTable';
import { SEOTableContainer } from './SEOTable.styles';
import { SEOTableProvider } from './useSEOTableConfig';
import Head from './Head';
import Body from './Body';

type SEOTableProps = SEOTableData;

const SEOTable = ({ head, table, firstColumnCustomWidth, textAlignment = 'center' }: SEOTableProps): JSX.Element => {
  const config = {
    firstColumnCustomWidth,
    head,
    table,
    textAlignment,
  };

  return (
    <SEOTableProvider config={config}>
      <SEOTableContainer>
        <Head />
        <Body />
      </SEOTableContainer>
    </SEOTableProvider>
  );
};

export default SEOTable;
